import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgRefreshClockFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 16"
    stroke="#4D4D4D"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.006 14a6.003 6.003 0 0 0 6.007-6c0-3.314-2.69-6-6.007-6A6.003 6.003 0 0 0 3 8c0 3.314 2.69 6 6.006 6Z"
      fill="#F8E71C"
    />
    <path d="M15.013 8c0-3.314-2.69-6-6.007-6a6.008 6.008 0 0 0-5.57 3.75M3 8c0 3.314 2.69 6 6.006 6a6.008 6.008 0 0 0 5.462-3.5" />
    <path d="m1.29 10.441 1.476-2.413 2.413 1.475m11.759-3.457-1.572 2.35-2.351-1.572m-6.21-1.777L9.283 8.44h3.029" />
  </svg>
);
const Memo = memo(SvgRefreshClockFill);
export default Memo;
